"use client";

import { useEffect, useRef } from "react";

type Auth0AutoRedirectProps = {
  callbackUrl: string;
};

/**
 * Full navigation to `/auth/login` (Auth0 SDK v4) — use `<a>`/location, not client-side `<Link>`,
 * per SDK guidance.
 */
export default function Auth0AutoRedirect({ callbackUrl }: Auth0AutoRedirectProps) {
  const hasTriggeredRedirectRef = useRef(false);

  useEffect(() => {
    if (hasTriggeredRedirectRef.current) {
      return;
    }
    hasTriggeredRedirectRef.current = true;
    const url = new URL("/auth/login", window.location.origin);
    url.searchParams.set("returnTo", callbackUrl);
    window.location.assign(url.toString());
  }, [callbackUrl]);

  return (
    <main style={{ padding: 24, fontFamily: "system-ui" }}>
      <p>Redirecting to Auth0...</p>
    </main>
  );
}
